module.exports = "<p class=\"pa-color pa-header borderless\" style=\"margin-bottom: 40px;\">\n    <label>Modalità Pagamento:</label>\n    <select class=\"form-control pa-color pa-header borderless\" style=\"margin: 0px;\" \n        ng-model=\"$ctrl.model\" \n        name=\"{{$ctrl.name}}\"\n        placeholder=\"Modalita Pagamento\" \n        >\n        <option value=\"{{value}}\" ng-repeat=\"(value, documentation) in $ctrl.modalitaPagamentoTypes\">\n            {{documentation}} </option>\n    </select>\n</p>";


//////////////////
// WEBPACK FOOTER
// ./src/app/sections/home/fatturazione/component/payment-mode-selector/payment-mode-selector.html
// module id = 782
// module chunks = 0